var userAgent = require('../internals/engine-user-agent');

module.exports = /web0s(?!.*chrome)/i.test(userAgent);



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/engine-is-webos-webkit.js